import React from 'react';
import { Box, IconButton, Typography, Avatar, Chip } from '@mui/material';
import { 
  Close as CloseIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon
} from '@mui/icons-material';
import { WebSocketConnectionState } from '../../../services/chatWebSocketService';
import lottoRecoIcon from 'assets/images/lottoReco-icon.png';

interface ChatHeaderProps {
  isUserInfoSubmitted: boolean;
  connectionState: WebSocketConnectionState;
  onMinimize: () => void;
  onClose: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  isUserInfoSubmitted,
  connectionState,
  onMinimize,
  onClose,
}) => {
  // Get connection status display
  const getConnectionStatus = () => {
    switch (connectionState) {
      case 'connected':
        return { icon: <WifiIcon />, label: 'Connected', color: 'success' as const };
      case 'connecting':
        return { icon: <WifiIcon />, label: 'Connecting...', color: 'warning' as const };
      case 'reconnecting':
        return { icon: <WifiIcon />, label: 'Reconnecting...', color: 'warning' as const };
      case 'disconnected':
        return { icon: <WifiOffIcon />, label: 'Disconnected', color: 'default' as const };
      case 'error':
        return { icon: <WifiOffIcon />, label: 'Connection Error', color: 'error' as const };
      default:
        return { icon: <WifiOffIcon />, label: 'Unknown', color: 'default' as const };
    }
  };

  return (
    <Box className="chat-header">
      <Box className="chat-header-content">
        <Avatar className="chat-avatar">
          <img src={lottoRecoIcon} alt="LottoReco" className="chat-avatar-image" />
        </Avatar>
        <Box className="chat-header-text">
        <Box className="chat-subtitle-container">
            <Typography variant="caption" className="chat-subtitle">
              We're here to help!
            </Typography>
            {/* {isUserInfoSubmitted && (
              <Chip
                icon={getConnectionStatus().icon}
                label={getConnectionStatus().label}
                color={getConnectionStatus().color}
                size="small"
                variant="outlined"
                className="connection-status-chip"
              />
            )} */}
          </Box>
          <Typography variant="h6" className="chat-title">
              LottoReco support
          </Typography>
        </Box>
      </Box>
      <Box className="chat-header-actions">
        {/* <IconButton
          onClick={onMinimize}
          size="small"
          className="minimize-button"
        >
          <Typography variant="h6">−</Typography>
        </IconButton> */}
        <IconButton
          onClick={onClose}
          size="small"
          className="close-button"
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatHeader;
